import axios from "axios";

const { REACT_APP_VEHICLES_API } = process.env;

const { CancelToken } = axios;
const source = CancelToken.source();

export const getVehicles = async () => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];

  try {
    const response = await axios({
      method: "get",
      url: `${REACT_APP_VEHICLES_API}/vehicles?results_per_page=2000&basic_only=true`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return { data: response.data, hasNextPage: response.data.has_next_page };
  } catch (e) {
    return { e };
  }
};

export const getVehiclesNew = async (
  customer,
  query = "",
  page = 1,
  results = 60,
  cancelToken = source.token,
  orderBy = "name",
  order = "asc",
  showGroups = false,
  filterBy = "",
) => {
  const url = `q=${query}&results_per_page=${results}&page=${page}&order_by=${orderBy}&order=${order}&fetch_status=false&show_vehicle_groups=${showGroups}`;
  const params = new URLSearchParams(url);
  if (filterBy) {
    params.set("filters", filterBy);
  }
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "get",
      url: `${REACT_APP_VEHICLES_API}/${customer}/vehicles?${params.toString()}`,
      headers: { Authorization: `Bearer ${token}` },
      cancelToken,
    });
    return { data: response.data };
  } catch (e) {
    return { e };
  }
};

export const getUngroupedVehicles = async (
  customer,
  page = 1,
  results = 60,
  cancelToken = source.token,
  orderBy = "name",
  order = "asc",
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "get",
      url: `${REACT_APP_VEHICLES_API}/${customer}/vehicles/ungrouped?results_per_page=${results}&page=${page}&order_by=${orderBy}&order=${order}}`,
      headers: { Authorization: `Bearer ${token}` },
      cancelToken,
    });
    return { data: response.data };
  } catch (e) {
    return { e };
  }
};

export const getVehicle = async (customer, vehicleId, fetch_status = false) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];

  try {
    const response = await axios({
      method: "get",
      url: `${REACT_APP_VEHICLES_API}/${customer}/vehicles/${vehicleId}?fetch_status=${fetch_status}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return { data: response.data };
  } catch (e) {
    return { e };
  }
};

export const createVehicle = async (customer, data) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "post",
      url: `${REACT_APP_VEHICLES_API}/${customer}/vehicles`,
      headers: { Authorization: `Bearer ${token}` },
      data,
    });
    return { data: response.data };
  } catch (e) {
    return { e };
  }
};

export const updateVehicle = async (customer, vehicleId, data) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "put",
      url: `${REACT_APP_VEHICLES_API}/${customer}/vehicles/${vehicleId}`,
      headers: { Authorization: `Bearer ${token}` },
      data,
    });
    return { data: response.data };
  } catch (e) {
    return { e };
  }
};

export const deleteVehicle = async (customer, id) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "delete",
      url: `${REACT_APP_VEHICLES_API}/${customer}/vehicles/${id}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return { data: response.data };
  } catch (e) {
    return { e };
  }
};

export const deleteVehicles = async (
  customerId: string,
  vehicleIds: string,
  query: string,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  const params = new URLSearchParams();
  if (vehicleIds && vehicleIds !== "all") {
    params.set("vehicle_ids_in", vehicleIds);
  } else if (query && vehicleIds && vehicleIds === "all") {
    params.set("q", query);
  }
  const response = await axios({
    method: "delete",
    url: `${REACT_APP_VEHICLES_API}/${customerId}/vehicles?${params.toString()}`,
    headers: { Authorization: `Bearer ${token}` },
  });
  return response?.data;
};

export const getVehicleTypes = async (customerId: string) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];

  try {
    const response = await axios({
      method: "get",
      url: `${REACT_APP_VEHICLES_API}/${customerId}/vehicle_types`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return { data: response.data };
  } catch (e) {
    return { e };
  }
};

export const downloadVehicles = async (
  customerId: string,
  vehicleIds: string,
  query: string,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];

  const response = await axios({
    method: "get",
    url: `${REACT_APP_VEHICLES_API}/${customerId}/vehicles/download?vehicles_ids_in=${vehicleIds}&q=${query}`,
    headers: { Authorization: `Bearer ${token}` },
  });
  return response?.data?.data;
};

export const importVehicles = async (customerId: string, vehicles: any) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "post",
      url: `${REACT_APP_VEHICLES_API}/${customerId}/vehicles/import`,
      headers: { Authorization: `Bearer ${token}` },
      data: vehicles,
    });
    return response;
  } catch (e) {
    return { e };
  }
};

export const addVehicleGroupToVehicle = async (
  customerId: string,
  vehicleGroupId: string,
  vehicleId: string,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "post",
      url: `${REACT_APP_VEHICLES_API}/${customerId}/vehicle_groups/${vehicleGroupId}/vehicles/${vehicleId}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (e) {
    return { e };
  }
};

export const removeVehicleGroupFromVehicle = async (
  customerId: string,
  vehicleGroupId: string,
  vehicleId: string,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "delete",
      url: `${REACT_APP_VEHICLES_API}/${customerId}/vehicle_groups/${vehicleGroupId}/vehicles/${vehicleId}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (e) {
    return { e };
  }
};
